/** @namespace routes */
import { register } from 'tmr/tmr/ngModuleRegistry'

import * as antennas from './antennas/antennas'
import * as antennasForm from './antennas/form'
// import * as antennasTest from './antennas/test'
import * as barcodeReaders from './barcodeReaders/barcodeReaders'
import * as barcodeReadersForm from './barcodeReaders/form'
import * as conveyors from './conveyors/conveyors'
import * as conveyorsForm from './conveyors/form'
import * as conveyorView from './conveyors/conveyor.view'
import * as deviceControllers from './deviceControllers/deviceControllers'
import * as deviceControllersForm from './deviceControllers/form'
import * as devices from './devices'
import * as printers from './printers/printers'
import * as printersForm from './printers/form'
// import * as rfidGates from './rfidGates/rfidGates'
// import * as rfidGatesForm from './rfidGates/form'
import * as rfidReaders from './rfidReaders/rfidReaders'
import * as rfidReadersForm from './rfidReaders/form'
import * as scanners from './scanners/scanners'
import * as scannersForm from './scanners/form'
import * as scannerView from './scanners/scanner.view'
import * as workstations from './workstations/workstations'
import * as workstationsForm from './workstations/form'
import * as xspans from './xspans/xspans'
import * as xspansForm from './xspans/form'
import * as xspansView from './xspans/xspan.view'

export default register(
  'tmr.core.routes.devices',
  devices,
  antennas,
  antennasForm,
  barcodeReaders,
  barcodeReadersForm,
  conveyors,
  conveyorsForm,
  conveyorView,
  deviceControllers,
  deviceControllersForm,
  printers,
  printersForm,
  scanners,
  scannersForm,
  scannerView,
  workstations,
  workstationsForm,
  rfidReaders,
  rfidReadersForm,
  xspans,
  xspansForm,
  xspansView
)
